import { createRef } from 'react';
import { create } from 'zustand';
import type WaveSurfer from 'wavesurfer.js';

interface ImageData {
  image_id: string;
  image_url: string;
}

export interface AudioMetaData {
  wav: Blob;
  fileSizeInMB: string;
  fileSize: number;
}

type VoiceScanState = {
  sessionId: string;
  imageData?: ImageData;
  isRecording: boolean;
  recordingsRef: React.RefObject<HTMLDivElement>;
  recordedWavesurfer?: WaveSurfer;
  audioMetaData?: AudioMetaData;
  recordingStartTime?: Date;
  duration: number;
};

type VoiceScanActions = {
  setImageData: (data?: ImageData) => void;
  setSessionId: (id: string) => void;
  setIsRecording: (isRecording: boolean) => void;
  setRecordedWavesurfer: (ws?: WaveSurfer) => void;
  setAudioMetaData: (meta?: AudioMetaData) => void;
  setRecordingStartTime: (time?: Date) => void;
  setDuration: (duration: number) => void;
  resetStore: () => void;
};

const initialState: VoiceScanState = {
  sessionId: '',
  imageData: undefined,
  isRecording: false,
  recordingsRef: createRef(),
  recordedWavesurfer: undefined,
  audioMetaData: undefined,
  recordingStartTime: undefined,
  duration: 0,
};

export const useVoiceScanStore = create<VoiceScanState & VoiceScanActions>(
  (set) => ({
    ...initialState,
    setImageData: (data) => set({ imageData: data }),
    setSessionId: (id) => set({ sessionId: id }),
    setIsRecording: (isRecording) => set({ isRecording }),
    setRecordedWavesurfer: (ws) => set({ recordedWavesurfer: ws }),
    setAudioMetaData: (meta) => set({ audioMetaData: meta }),
    setRecordingStartTime: (time) => set({ recordingStartTime: time }),
    setDuration: (duration) => set({ duration }),
    resetStore: () => set(initialState),
  })
);
